import { useEffect, useMemo, type ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { useProjects } from "../../projects/projectContext";
import { useSession } from "../../session/sessionContext";
import { csrfTokenOf } from "../../session/sessionMachine";
import { ItemNameCache } from "./itemNameCache";
import { ItemNameContext } from "./itemNameContext";

export default function ItemNameProvider({ children }: { children: ReactNode }) {
  const { i18n } = useTranslation();
  const language = i18n.resolvedLanguage;
  const { session } = useSession();
  const { selectedProjectId } = useProjects();
  const sessionKey = csrfTokenOf(session);
  const cache = useMemo(() => new ItemNameCache(sessionKey, selectedProjectId, undefined, language), [sessionKey, selectedProjectId, language]);
  useEffect(() => () => { cache.clear(); }, [cache]);
  return <ItemNameContext.Provider value={cache}>{children}</ItemNameContext.Provider>;
}
